import React from 'react';

import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { Button } from 'src/components/common';

export const SuccessfulCard: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(appRoutes.auth.login);
  };

  return (
    <Box display="flex" justifyContent="center" flexDirection="column">
      <Box mb={4}>
        <Typography fontSize="24px">We remembered you! Check your mailbox</Typography>
        <Typography fontSize="16px" color="text.secondary">
          The link to reset your password should already be there
        </Typography>
      </Box>
      <Box alignSelf="center">
        <Button variant="contained" color="primary" onClick={handleNavigate}>
          Great!
        </Button>
      </Box>
    </Box>
  );
};
